import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { PopupBuyPackage } from '.'
import { selectUserProfile } from '../../../../common/category/store/slice'
import { PopupBuyNow } from '../popupBuyNow'

export const DisplayPopupBuyPackage = () => {
  const userProfile = useSelector(selectUserProfile)

  const [isShow, setIsShow] = useState(false)
  const [isOpenBuyNow, setIsOpenBuyNow] = useState(false)

  const location = useLocation()

  const { buyNow } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    if (buyNow) {
      setIsShow(true)
    }
  }, [buyNow])

  return (
    <>
      {isShow && (
        <PopupBuyPackage
          isShow={isShow}
          setIsShow={setIsShow}
          setIsOpenBuyNow={setIsOpenBuyNow}
          userProfile={userProfile}
        />
      )}
      {isOpenBuyNow && (
        <PopupBuyNow
          isShow={isOpenBuyNow}
          setIsShow={setIsOpenBuyNow}
          userProfile={userProfile}
          isBuyPackage
        />
      )}
    </>
  )
}
